import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const ImageButton = () => {
    const [gallery, setGallery] = useState([]);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/srilanka'); // e.g., '/contact' or '/booking'
      };

    useEffect(() => {
        const hardCodedImages = [
            { imageData: "/images/sigiriya.png", link: "/recom" },

        ];
        setGallery(hardCodedImages);
    }, []);

    return (
        <div className="image-button-container">
            {/* Left column: Images */}
            <div className="image-column">
              {gallery.map((item, index) => (
                <img
                  src={item.imageData}

                  className="button-image"
                  key={index}
                />
              ))}
            </div>


            {/* Right column: Text */}
            <div className="text-column">
                <h1 className="section-heading">Turn Your Trip into a <br/><strong>Sri Lankan </strong><br/>Story Worth Telling!</h1>
                <h1 className="section-para">
                    At Wasala Tours, we don’t just take you places, we craft experiences.
                    From the moment you arrive, you’ll be greeted with a heartfelt ‘Ayubowan’and treated like family.<br/>
                    Our friendly, knowledgeable team is here to guide you every step of the way, ensuring your journey is not only comfortable but deeply memorable.
                    Whether it’s a peaceful beach escape, a cultural adventure, or a wild nature trek, we offer personalized
                    service with warmth, care, and a genuine smile. Let us turn your trip into a story you’ll cherish forever.
                </h1>


                        <button className="tour-button2" onClick={handleClick}>Explore the Wonders of Sri Lanka</button>

            </div>
        </div>
    );
};

export default ImageButton;
